import * as Yup from 'yup';
import { getFormattedDateYmd } from '../../../global/helpers/date-helpers';
import { getRequiredText } from '../../../global/helpers/transformer';
import { YesNoIndicators } from '../../../global/models/api-model';
import { LabelSettingProps } from '../../../global/models/epi-model';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { InstitutionInfo } from '../model/clergy-bio-app-models';
import { ClergyBioVolunteerFormModel } from './models/form-models';

export function GetClergyBioVolunteerValidationSchema(settings: ClergyBioSettings, labelSetting: LabelSettingProps) {

	const episcopalShape = Yup.object().shape({
		dateBegan: Yup.date().nullable().when(['delete'], {
			is: (a) => a !== YesNoIndicators.Yes,
			then: Yup.date().nullable().required(getRequiredText(labelSetting.requiredFormat, settings.positionStartDateLabel)),
		}),
		dateEnded: Yup.date().nullable(),
		institutionParsed: Yup.string().nullable().when(['delete'], {
			is: (a) => a !== YesNoIndicators.Yes,
			then: Yup.string().nullable()
				.test('institutionInfo', settings?.errorMessageWhenNotSelectingFromAutoComplete, function () {
					const { institutionInfo } = this.parent;
					return institutionInfo;
				}),
		}),
		position: Yup.string().when(['delete'], {
			is: (a) => a !== YesNoIndicators.Yes,
			then: Yup.string().required(getRequiredText(labelSetting.requiredFormat, settings.positionLabel)),
		}),
	});
	const miscellaneousShape = Yup.object().shape({
		dateBegan: Yup.date().nullable().when(['delete'], {
			is: (a) => a !== YesNoIndicators.Yes,
			then: Yup.date().nullable().required(getRequiredText(labelSetting.requiredFormat, settings.positionStartDateLabel)),
		}),
		dateEnded: Yup.date().nullable(),
		institutionInfo: Yup.string().nullable().when(['delete'], {
			is: (a) => a !== YesNoIndicators.Yes,
			then: Yup.string().nullable().required(getRequiredText(labelSetting.requiredFormat, settings.miscellaneousInstitutionLabel)),
		}),
		position: Yup.string().when(['delete'], {
			is: (a) => a !== YesNoIndicators.Yes,
			then: Yup.string().required(getRequiredText(labelSetting.requiredFormat, settings.positionLabel)),
		}),
	});


	return Yup.object().shape({
		episcopal: Yup.array()
			.of(episcopalShape),
		miscellaneous: Yup.array()
			.of(miscellaneousShape),
	});
}

export function ConstructPayload(values: ClergyBioVolunteerFormModel) {
	return {
		volunteer_positions: {
			tec_volunteer: values?.episcopal?.filter(a => a.id || (!a?.id && a?.deleted !== YesNoIndicators.Yes))?.map(a => {
				return {
					id: a?.id,
					employer_id: (a?.institutionInfo as InstitutionInfo)?.id,
					position_title: a?.position,
					position_start_date: getFormattedDateYmd(a?.dateBegan, true),
					position_end_date: getFormattedDateYmd(a?.dateEnded, true),
					deleted: a?.deleted,
				};
			}),
			miscellaneous: values?.miscellaneous?.filter(a => a.id || (!a?.id && a?.deleted !== YesNoIndicators.Yes))?.map(a => {
				return {
					id: a?.id,
					employer_name: a?.institutionInfo,
					position_title: a?.position,
					position_start_date: getFormattedDateYmd(a?.dateBegan, true),
					position_end_date: getFormattedDateYmd(a?.dateEnded, true),
					deleted: a?.deleted,
				};
			}),
		},
	};

}

export function CreateNewVolunteerItem() {
	return {
		employeeId: '',
		employerId: '',
		dateBegan: null,
		dateEnded: null,
		position: '',
		institutionInfo: null,
		deleted: null,
		institutionParsed: '',
	};
}